import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from '../components.module';
import { FooterComponentModule } from '../components/footer/footer.module';
import { PrintDrugLabelPage } from './print-drug-label';
import { PrintDrugLabelPageRoutingModule } from './print-drug-routing.module';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';

@NgModule({
  declarations: [PrintDrugLabelPage],
  imports: [IonicModule, CommonModule, ComponentsModule, FooterComponentModule, PrintDrugLabelPageRoutingModule],
  providers: [Printer],
})
export class PrintDrugLabelPageModule {}
